import { Navbar, Container, Nav } from "react-bootstrap";

const Menu = () => {
  return (
    <>
      <Navbar
        className="navbar"
        collapseOnSelect
        expand="lg"
        /* bg="#00b0a5" */ variant="dark"
        sticky="top"
      >
        <Container>
          <Navbar.Brand href="#home">
            <img
              src="/assets/images/logo.png"
              alt="logo-image"
              widht="100"
              height="100"
            />
            &ensp;<h1>Ficha del Paciente</h1>
          </Navbar.Brand>

          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Navbar.Collapse
            className="justify-content-end"
            id="responsive-navbar-nav"
          >
            <Nav>
              <Nav.Link className="nav-link text-white" href="#historiaClinica">
                Historia Clinica
              </Nav.Link>
              <Nav.Link className="nav-link text-white" href="#evaluacion">
                Evaluación
              </Nav.Link>
              <Nav.Link className="nav-link text-white" href="#resultados">
                Resultados
              </Nav.Link>
              <Nav.Link className="nav-link text-white" href="#planCorrectivo">
                Plan Correctivo
              </Nav.Link>
              {/* <Nav.Link className="nav-link text-white"  href="#sesionesCorrectivas">
                Sesiones Correctivas
              </Nav.Link> */}
              <Nav.Link className="nav-link text-white" href="#fotos">
                Fotos
              </Nav.Link>
              <Nav.Link
                onClick={() => {
                 /*  sessionStorage.setItem("reloading", "true");

                  window.location.reload(false); */

                  /* setTimeout(() => {
                    window.location.reload(false);
                  }, 1000); */
                }}
                className="nav-link text-white"
                href="#pdf"
              >
                PDF
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  );
};

export default Menu;
